require.resolve("!/usr/share/hubspot/build/workspace/growthhub-ui/node_modules/bender-lyaml-loader/lib/index.js??ref--0-oneOf-0-rules-10!./en.lyaml?sporks");

export default {
  mode: "lazy",
  source: "growthhub-ui/lang",
  context: {
    "en": function () { return import("!/usr/share/hubspot/build/workspace/growthhub-ui/node_modules/bender-lyaml-loader/lib/index.js??ref--0-oneOf-0-rules-10!./en.lyaml?sporks" /* webpackChunkName: "growthhub-ui-lang-en" */); }  }
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/bender-i2l-loader/lib?query=sporks!./lang/en.lyaml
// module id = 145
// module chunks = 177 178